import currentUserModule from "./currentUserModule"

currentUserModule.controller("currentUserController", ["$scope", "authenticationService", "changePasswordModal", "currentUserService", ($scope, authenticationService, changePasswordModal, currentUserService) => {
    $scope.logOut = () => {
        return currentUserService.logout()
    }

    $scope.currentUserName = authenticationService.getCurrentUserName()

    $scope.changePassword = () => {
        changePasswordModal({username: $scope.currentUserName}, true)
    }
}])